import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Input } from '@angular/core';
import { MapService } from '../map.service';
import { ILocation } from '../models/iLocation';

@Component({
  selector: 'rc-address-card',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.scss']
})
export class AddressCardComponent {

  constructor(
    private mapService: MapService
  ) {
  }

  @Input() location: ILocation;
  @Input() selectedLocationTitle = '';
  @Input() isAccountingDisabled = false;
  @Output() editClickEmitter: EventEmitter<ILocation> = new EventEmitter();
  @Output() deleteClickEmitter: EventEmitter<ILocation> = new EventEmitter();

  edit(){
    this.editClickEmitter.emit(this.location);
  }

  delete(){
    this.deleteClickEmitter.emit(this.location);
  }

  checkIfSelected() {
    try {
      if (this.location.Title === this.selectedLocationTitle){
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }

  }

  getEditBtnClass() {
    return this.mapService.editBtnClass;
  }

  getPrimaryCondition() {
    return this.location.IsPrefered;
  }

  getAccountingCondition() {
    return this.location.IsAccounting && !this.isAccountingDisabled;
  }

}
